import React, { useState } from 'react';
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from '@mui/x-data-grid';
import { Box, Button } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

export default function CustomToolbar({ onExport }) {
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    setExporting(true);
    try {
      await onExport(); // Wait for the export function to finish
    } finally {
      setExporting(false);
    }
  };

  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <Box sx={{ marginLeft: 'auto', paddingRight: 2 }}>
        <Button
          variant="outlined"
          size="small"
          onClick={handleExport}
          startIcon={<FileDownloadIcon />}
          disabled={exporting} // Disable button while exporting
        >
          {exporting ? 'Exporting...' : 'Export'}
        </Button>
      </Box>
    </GridToolbarContainer>
  );
}
